import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ADMIN_LOGIN_PATH, ADMIN_CHANGE_PASSWORD_PATH } from '../../context/SecurityContext';
import AdminLayout from './AdminLayout';
import LoadingSpinner from '../LoadingSpinner';

/**
 * /admin/login: pantalla de auth a pantalla completa (estilo Nestify, sin navbar/footer).
 * Resto de /admin/*: layout con sidebar.
 */
const AdminRouteWrapper = () => {
  const location = useLocation();
  const isAuthFullPage =
    location.pathname === ADMIN_LOGIN_PATH || location.pathname === ADMIN_CHANGE_PASSWORD_PATH;

  const outlet = (
    <Suspense fallback={<LoadingSpinner containerClass="admin-page" />}>
      <div className="ui-page-enter">
        <Outlet />
      </div>
    </Suspense>
  );

  if (isAuthFullPage) {
    return outlet;
  }

  return <AdminLayout>{outlet}</AdminLayout>;
};

export default AdminRouteWrapper;
